export const LIST_CONTAINER_VERTICAL_PADDING = 16;
export const POST_EDITOR_ERROR_CLASS = 'post-editor-error-class';
// default value for the List Items Container top / bottom paddings defined in src/components/containers/ListItemContainer.module.scss
